import 'whatwg-fetch'
const env = process.env;

const storeControllerCommand = (params) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/controllerCommands?access_token=${params.apitoken}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.payload)
    })
}

export default {
    storeControllerCommand,
}
